import i18n from '../../i18n';
export const formatBytes = (bytes, decimals = 0) => {
    if (bytes === 0)
        return '0 Bytes';
    const k = Math.pow(2, 10);
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + (sizes[i] || '');
};
export const getMaxSizeErrorMessage = (sizeInBytes) => {
    const formattedBytes = formatBytes(sizeInBytes);
    return i18n.$gettext('Please choose a file smaller than %{size}', { size: `${formattedBytes}` });
};
function getHandleLoadEnd(fileInput, onSuccess, onError) {
    return progressEvent => {
        var _a;
        const file = fileInput.files[0];
        // having called readAsDataURL makes the result a string
        const base64File = (_a = progressEvent.target) === null || _a === void 0 ? void 0 : _a.result;
        const maxSizeInBytes = 25 * 1024 * 1024;
        if (base64File && base64File.substring(0, 11) !== 'data:image/') {
            alert(window.steadyI18n.errors.imageFileFormat);
            onError(fileInput);
        }
        else if (file && file.size > maxSizeInBytes) {
            alert(getMaxSizeErrorMessage(maxSizeInBytes));
            onError(fileInput);
        }
        else if (file && base64File) {
            onSuccess(fileInput, file, base64File);
        }
    };
}
export default function readFile(fileInput, onSuccess, onError) {
    const reader = new FileReader();
    const file = fileInput.files[0];
    reader.onloadend = getHandleLoadEnd(fileInput, onSuccess, onError);
    if (file) {
        reader.readAsDataURL(file); // triggers onloadend
    }
}
